// // free-gift 

// /**
//  * free-gift.js
//  * Free Gift With Purchase — Studio Rose Sample
//  * First 150 qualifying orders only.
//  *
//  * Drop this file into your Shopify theme's /assets/ folder.
//  * Include it in layout/theme.liquid via the free-gift-init.liquid snippet.
//  *
//  * Eligibility: cart must contain at least one line item whose product_id
//  * is in ELIGIBLE_PRODUCT_IDS. Variant IDs are intentionally NOT checked —
//  * any size/color of the four main products qualifies.
//  *
//  * The 150-order counter comes from the shop metafield:
//  *   namespace: promotion
//  *   key:       gift_orders_count
//  * That value is injected by the Liquid snippet at page load.
//  * It is refreshed from /cart.js on each sync but the metafield itself
//  * is only updated by the backend webhook (see gift-order-webhook.js).
//  */

// const FreeGift = (() => {
//   // ─── Constants ────────────────────────────────────────────────────────────

//   const ELIGIBLE_PRODUCT_IDS = [
//     "9575275299043",
//     "9575274840291",
//     "9575274447075",
//     "9575272513763",
//   ];

//   const GIFT_VARIANT_ID = '49519010087139';
//   const GIFT_PRODUCT_ID  = '9598834114787';
//   const PROMOTION_LIMIT  = 150;

//   // ─── State ────────────────────────────────────────────────────────────────

//   let promotionOrderCount = 0; // set by init() from Liquid-rendered value
//   let isSyncing = false;       // prevents overlapping sync calls

//   // ─── Public API ───────────────────────────────────────────────────────────

//   /**
//    * Call once on DOMContentLoaded with the current order count from the
//    * shop metafield (rendered by Liquid so no extra API call is needed).
//    *
//    * @param {number|string} orderCount  Current value of promotion.gift_orders_count
//    */
//   function init(orderCount) {
//     promotionOrderCount = parseInt(orderCount, 10) || 0;
//     _attachListeners();
//     // Run once immediately in case the page loaded with items already in cart
//     _triggerSync();
//   }

//   // ─── Event wiring ─────────────────────────────────────────────────────────

//   function _attachListeners() {
//     document.addEventListener('cart:update', _triggerSync); 
//     // Your theme's custom cartUpdate event (dispatched after product-card
//     // and BYOS add-to-cart calls). Match the exact string ThemeEvents.cartUpdate
//     // resolves to in your events.js — change this if it differs.
//     document.addEventListener('theme:cart:update', _triggerSync);

//     // Standard Horizon / Dawn cart events — belt-and-suspenders coverage
//     document.addEventListener('cart:updated', _triggerSync);
//     document.addEventListener('cart:refresh', _triggerSync);
//   }

//   function _triggerSync() {
//     if (isSyncing) return;
//     isSyncing = true;
//     _syncGift().finally(() => { isSyncing = false; });
//   }

//   // ─── Core sync logic ──────────────────────────────────────────────────────

//   async function _syncGift() {
//     let cart;
//     try {
//       cart = await _fetchCart();
//     } catch (err) {
//       console.warn('[FreeGift] Could not fetch cart:', err);
//       return;
//     }

//     const eligible     = _cartIsEligible(cart);
//     const giftIndex    = _findGiftLineIndex(cart);   // -1 if not present
//     const giftInCart   = giftIndex !== -1;
//     const promoOpen    = promotionOrderCount < PROMOTION_LIMIT;

//     if (eligible && promoOpen && !giftInCart) {
//       // ✅ Qualifying cart, promotion still running, gift not yet added
//       await _addGift();

//     } else if (giftInCart && (!eligible || !promoOpen)) {
//       // ❌ Gift is in cart but cart no longer qualifies OR promotion closed
//       await _removeGift(giftIndex);
//     }
//     // All other states (eligible+open+gift already present, not eligible+no gift)
//     // require no action.
//   }

//   // ─── Eligibility check ────────────────────────────────────────────────────

//   function _cartIsEligible(cart) {
//     // Checks product_id — not variant ID — so any size/color counts.
//     // Covers individual product adds AND bundle lines (BYOS adds the real
//     // product variants, so their product_ids appear here directly).
//    return cart.items.some(
//   (item) => ELIGIBLE_PRODUCT_IDS.includes(String(item.product_id))
// );
//   }

//   function _findGiftLineIndex(cart) {
//     return cart.items.findIndex(
//   (item) => String(item.product_id) === GIFT_PRODUCT_ID
// );
//   }

//   // ─── Cart mutations ───────────────────────────────────────────────────────

//   async function _addGift() {
//     let res;
//     try {
//       res = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           items: [{
//             id: GIFT_VARIANT_ID,
//             quantity: 1,
//             properties: {
//               // Line-item properties help the warehouse identify this SKU.
//               // They also let us find and remove the gift later if needed.
//               _free_gift: 'studio_rose_sample',
//               _promotion: 'first_150_orders',
//             },
//           }],
//         }),
//       });
//     } catch (err) {
//       console.warn('[FreeGift] Failed to add gift:', err);
//       return;
//     }

//     if (!res.ok) {
//       console.warn('[FreeGift] /cart/add.js returned', res.status, res);
//       return;
//     }

//     await _broadcastCartUpdate();
//   }

//   async function _removeGift(giftLineIndex) {
//     // /cart/change.js uses 1-based line numbers
//     const lineNumber = giftLineIndex + 1;
//     let res;
//     try {
//       res = await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ line: lineNumber, quantity: 0 }),
//       });
//     } catch (err) {
//       console.warn('[FreeGift] Failed to remove gift:', err);
//       return;
//     }

//     if (!res.ok) {
//       console.warn('[FreeGift] /cart/change.js returned', res.status);
//       return;
//     }

//     await _broadcastCartUpdate();
//   }

//   // ─── Helpers ──────────────────────────────────────────────────────────────

//   async function _fetchCart() {
//     const res = await fetch('/cart.js');
//     if (!res.ok) throw new Error(`/cart.js ${res.status}`);
//     return res.json();
//   }

//   async function _broadcastCartUpdate() {
//   // Directly trigger a section re-render on the cart items component
//   // without dispatching any events that could interfere with the drawer
//   const cartItemsEl = document.querySelector('cart-items-component');
//   if (!cartItemsEl) return;

//   const sectionId = cartItemsEl.dataset.sectionId;
//   if (!sectionId) return;

//   try {
//     const res = await fetch(
//       `${window.location.pathname}?sections=${sectionId}`,
//       { headers: { 'Content-Type': 'application/json' } }
//     );
//     const sectionsData = await res.json();
//     const html = sectionsData[sectionId];
//     if (!html) return;

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, 'text/html');
//     const newCartItems = doc.querySelector('cart-items-component');
//     const oldCartItems = document.querySelector('cart-items-component');

//     if (newCartItems && oldCartItems) {
//       oldCartItems.innerHTML = newCartItems.innerHTML;
//     }
//   } catch (err) {
//     console.warn('[FreeGift] Section refresh failed:', err);
//   }
// }

//   // ─── Exports ──────────────────────────────────────────────────────────────

//   return { init };
// })();


// free-gift.js
/**
 * free-gift.js
 * Free Gift With Purchase — Studio Rose Sample
 * First 150 qualifying orders only.
 */

const FreeGift = (() => {
  const ELIGIBLE_PRODUCT_IDS = [
    "9575275299043",
    "9575274840291",
    "9575274447075",
    "9575272513763",
  ];

  const GIFT_VARIANT_ID = '49519010087139';
  const GIFT_PRODUCT_ID  = '9598834114787';
  const PROMOTION_LIMIT  = 150;

  let promotionOrderCount = 0;
  let isSyncing = false;

  function init(orderCount) {
    promotionOrderCount = parseInt(orderCount, 10) || 0;
    _attachListeners();
    _triggerSync();
  }

  function _attachListeners() {
    document.addEventListener('cart:update', _triggerSync);
    document.addEventListener('theme:cart:update', _triggerSync);
    document.addEventListener('cart:updated', _triggerSync);
    document.addEventListener('cart:refresh', _triggerSync);
  }

  function _triggerSync() {
    if (isSyncing) return;
    isSyncing = true;
    _syncGift().finally(() => { isSyncing = false; });
  }

  async function _syncGift() {
    let cart;
    try {
      cart = await _fetchCart();
    } catch (err) {
      console.warn('[FreeGift] Could not fetch cart:', err);
      return;
    }

    const eligible     = _cartIsEligible(cart);
    const giftIndex    = _findGiftLineIndex(cart);
    const giftInCart   = giftIndex !== -1;
    const promoOpen    = promotionOrderCount < PROMOTION_LIMIT;

    if (eligible && promoOpen && !giftInCart) {
      await _addGift();
    } else if (giftInCart && (!eligible || !promoOpen)) {
      await _removeGift(giftIndex);
    }
  }

  function _cartIsEligible(cart) {
    return cart.items.some(
      (item) => ELIGIBLE_PRODUCT_IDS.includes(String(item.product_id))
    );
  }

  function _findGiftLineIndex(cart) {
    return cart.items.findIndex(
      (item) => String(item.product_id) === GIFT_PRODUCT_ID
    );
  }

  async function _addGift() {
    let res;
    try {
      res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: {
              _free_gift: 'studio_rose_sample',
              _promotion: 'first_150_orders',
            },
          }],
        }),
      });
    } catch (err) {
      console.warn('[FreeGift] Failed to add gift:', err);
      return;
    }

    if (!res.ok) {
      console.warn('[FreeGift] /cart/add.js returned', res.status, res);
      return;
    }

    await _broadcastCartUpdate();
  }

  async function _removeGift(giftLineIndex) {
    const lineNumber = giftLineIndex + 1;
    let res;
    try {
      res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineNumber, quantity: 0 }),
      });
    } catch (err) {
      console.warn('[FreeGift] Failed to remove gift:', err);
      return;
    }

    if (!res.ok) {
      console.warn('[FreeGift] /cart/change.js returned', res.status);
      return;
    }

    await _broadcastCartUpdate();
  }

  async function _fetchCart() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error(`/cart.js ${res.status}`);
    return res.json();
  }

  /**
   * FIX: No longer fetches/morphs the shared header-actions section HTML
   * ourselves. That was clobbering <cart-icon>, which lives in the SAME
   * section as the cart drawer (see header-actions.liquid) — morphing the
   * whole section disconnected/reconnected the cart-icon element and broke
   * its ability to process any later cart:update events, freezing the
   * header count.
   *
   * Now we only dispatch itemCount + the fresh cart resource. cart-icon.js
   * updates instantly from itemCount alone. Since we deliberately omit
   * `sections`, cart-items-component's own #handleCartUpdate falls back to
   * its existing `sectionRenderer.renderSection(...)` path (the same one
   * already used for discount updates) to refresh the drawer's line items —
   * a safe, already-tested path that doesn't touch the header.
   */
  async function _broadcastCartUpdate() {
    let cart;
    try {
      cart = await _fetchCart();
    } catch (err) {
      console.warn('[FreeGift] Could not refetch cart for broadcast:', err);
      return;
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'free-gift',
          data: {
            source: 'free-gift',
            itemCount: cart.item_count,
          },
        },
      })
    );
  }

  return { init };
})();